var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-12 bottom-section justify-center align-center"},[_c('v-btn',{staticClass:"ss-btn-text",attrs:{"to":{ name: 'dashboard' }}},[_vm._v(" "+_vm._s(_vm.$t('buttons.takeToDashboard'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }